import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ProductIncomingModal, { IStateProps, IDispatchProps, IOwnProps } from './ProductIncomingModal'
import {
  DashboardAction,
  requestProductAccept,
} from '../../services/store/actions/dashboard/DashboardAction'

import  { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(): IStateProps {
  return {}
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestProductAccept: (product) => dispatch(requestProductAccept({product})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ProductIncomingModal)
